import { render, staticRenderFns } from "./IndReport.vue?vue&type=template&id=5428625e&scoped=true&"
import script from "./IndReport.vue?vue&type=script&lang=js&"
export * from "./IndReport.vue?vue&type=script&lang=js&"
import style0 from "./IndReport.vue?vue&type=style&index=0&id=5428625e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5428625e",
  null
  
)

export default component.exports